export const selectCustomStyle = {
  option: (provided: any, state: any) => ({
    ...provided,
    color: state.isSelected && state.isFocused
    ? '#FFF'
    : state.isSelected
    ? '#FFF'
    : state.isFocused
    ? '#FFF'
    : '#000',
    fontWeight: '500',
    backgroundColor:
      state.isSelected && state.isFocused
        ? '#e74c3c'
        : state.isSelected
        ? '#C74c3c'
        : state.isFocused
        ? '#B74c3c'
        : '#FFF',
    '&:active': {
      backgroundColor: '#e74c3c10',
    },
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#5e627800' : '#5e627800',
    boxShadow: state.isFocused ? '#5e627850' : '#5e627850',
    '&:hover': {
      borderColor: state.isFocused ? '#5e627800' : '#5e627800',
      boxShadow: state.isFocused ? '#5e6278ac' : '#5e6278ac',
      backgroundColor: '#e4e6ef',
    },
    backgroundColor: '#f5f8fa',
    height: 40,
    borderRadius: '0.475rem',
  }),
}

export const selectDarkCustomStyle = {
  singleValue: (base: any, props: any) => {
    return {
      ...base,
      color: '#FFF',
    }
  },
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor:
      state.isSelected && state.isFocused
        ? '#e74c3c'
        : state.isSelected
        ? '#C74c3c'
        : state.isFocused
        ? '#B74c3c'
        : '#1b1b29',
    '&:active': {
      backgroundColor: '#1b1b29',
    },
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#5e627800' : '#5e627800',
    boxShadow: state.isFocused ? '#5e627850' : '#5e627850',
    '&:hover': {
      borderColor: state.isFocused ? '#5e627800' : '#5e627800',
      boxShadow: state.isFocused ? '#5e6278ac' : '#5e6278ac',
      backgroundColor: '#2b2b40',
    },
    backgroundColor: '#1b1b29',
    height: 40,
    borderRadius: '0.475rem',
  }),
}